"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deconstruct = exports.inr = exports.inl = void 0;
const inl = (l) => ({ kind: "l", v: l });
exports.inl = inl;
const inr = (r) => ({ kind: "r", v: r });
exports.inr = inr;
const deconstruct = (onL, onR, v) => v.kind == "l" ? onL(v.v) : onR(v.v);
exports.deconstruct = deconstruct;
